const breakpoints = {
  mobile: {
    max: 479,
  },
  fablet: {
    min: 480,
    max: 777,
  },
  tablet: {
    min: 768,
    max: 1039,
  },
  desktop: {
    min: 1040,
  },
};

const getBreakpointQuery = key => {
  const breakpoint = breakpoints[key];
  if (!breakpoint) {
    throw new Error(`The key: ${key} is not a known breakpoint key`);
  }

  const breakpointKeys = Object.keys(breakpoint);

  if (breakpointKeys.includes('min') && breakpointKeys.includes('max')) {
    return `(min-width: ${breakpoint.min}px) and (max-width: ${
      breakpoint.max
    }px)`;
  } else if (breakpointKeys.includes('max')) {
    return `(max-width: ${breakpoint.max}px)`;
  } else if (breakpointKeys.includes('min')) {
    return `(min-width: ${breakpoint.min})`;
  }
};

module.exports = {
  breakpoints,
  getBreakpointQuery,
};



// WEBPACK FOOTER //
// ./src/common/config/breakpoints.js